import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {inject} from '@angular/core';
import {tap} from 'rxjs/operators';
import {AuthService} from './services/auth.service';

export const tokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse && event.headers.get('X-Token-Refresh') === 'true') {
                authService.refreshToken();
            }
        })
    );
};
